import { ModalCenter, ModalFullscreen, ModalWrapper } from "./ui"

export * from "./ui"

export const Modal = {
  Wrapper: ModalWrapper,
  Center: ModalCenter,
  Fullscreen: ModalFullscreen
}
